export type InfoByInn = {
	id: string;
	titleShort: string;
	status: CompanyStatus;
	inn: string;
	ogrn: string;
	foundingYear: number;
	legalAddress: string;
	okvedCode: string;
	okvedName: string;
	directorName: string;
	revenue: string;
	financialResult: FinancialResult;
	taxDebt: TaxDebt;
	courtDisputes: CountDisputes;
	invalidity: boolean;
	employeesCount: number;
};

export enum CompanyStatus {
	ACTIVE = 'ACTIVE',
	LIQUIDATING = 'LIQUIDATING',
	LIQUIDATED = 'LIQUIDATED',
	BANKRUPT = 'BANKRUPT',
	REORGANIZING = 'REORGANIZING',
}

export enum FinancialResult {
	PROFIT = 'profit', // Прибыль
	LOSS = 'loss', // Убыток
	ZERO = 'zero', // Нулевой
	UNKNOWN = 'unknown', // Нет данных
}

export enum TaxDebt {
	NONE = 'none', // Отсутствует
	PRESENT = 'present', // Имеется
	UNKNOWN = 'unknown', // Нет данных
}

export enum CountDisputes {
	NONE = 'none', // Не выявлены
	PRESENT = 'present', // Имеется
	UNKNOWN = 'unknown', // Нет данных
}
